import { Outlet } from 'react-router-dom';
import Header from './Header';

export default function BookingLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-[#FAFBFC]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
